declare type Routes = 'Login' | 'Home' | 'BookingList' | 'Booking' | 'Bookingscreditflight';

export const siteRoutes: Record<Routes, string> = {
  Login: 'login',
  Home: 'home',
  BookingList: 'bookinglist',
  Booking: 'booking',
  Bookingscreditflight: 'bookingcreditflight'
};

export const ProfessionalSection = 'Agency';
